export const MOBILE_NUMBER = "38 (063) 820 75 31";
export const TELEGRAM_ACCOUNT = "Sweet_Clean";

